import { CSSResultArray } from 'lit';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/select-native/js/design-tokens-px.css.js';
import style from './mc-select-native.scss';
export const styles: CSSResultArray = [tokens, style];
